"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortFilterDirectionType = void 0;
var SortFilterDirectionType;
(function (SortFilterDirectionType) {
    // This values are in lowercase because we needed like this in firestore
    SortFilterDirectionType["ASC"] = "asc";
    SortFilterDirectionType["DESC"] = "desc";
})(SortFilterDirectionType = exports.SortFilterDirectionType || (exports.SortFilterDirectionType = {}));
